<template>
    <div class="home-page menu-bg">
		<Header></Header>
		<div class="content">
      <div class="nav flex">
      	<div class="back" @click="back">
      		<img src="static/images/return.png" />
      	</div>
      	<span class="">{{$t('profile')}}</span>
      </div>
			<div class="information mt20">
        <div class="personal-info mt20">
            <div class="input-div">
              <div class="span fs33 fw7">- {{$t('Name')}} -</div>
              <div class="input-item">
                <input class="input" v-model="info.nickname" placeholder="">
              </div>
            </div>
            <div class="input-div">
              <div class="span fs33 fw7">- {{$t('phoneNumber')}} -</div>
              <div class="input-item">
                <input disabled class="input" v-model="info.mobile" placeholder="">
              </div>
            </div>
            <div class="input-div">
              <div class="span fs33 fw7">- {{$t('address')}} -</div>
              <div class="input-item">
                <input class="input" v-model="info.address" placeholder="">
              </div>
            </div>
            <div class="ac mt50">
              <button class="btn btn-blue info-button" @click="getSubmit"><!-- <img src="../../static/images/save.png" /> -->{{$t('Save')}}</button>
            </div>
        </div>
			</div>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
import Dialog from '../components/dialog'

export default {
    components:{
		Header,
    Dialog
    },
    data() {
        return {
          disAbled:'',
          edit:'Edit',
          isEdit:false,
          nickname:'',
          info:{
            'nickname':'',

          }

        }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.edit = this.$t('Edit')
		this.getHome();

	},
    methods: {
		back(){
			this.$router.go(-1);
		},
    getSubmit(){
    	let that = this;
      let data = {
        'nickname':that.info.nickname,
         'address':that.info.address
      }
      that.$parent.loadModal(true);
    	that.$api.post('/api/user/profile',data,r =>{
    		that.$parent.returnCode(r,function(){
    			that.getHome()
    	    that.isEdit = false;
    			that.$parent.loadModal(false);
          that.$router.go(-1);
    		});
    	})
    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
        });

			})
		}
	}
}
</script>
<style>
  .info-button{}
  .info-button img{margin-right: 10px;}
</style>



// WEBPACK FOOTER //
// src/page/personalInfo.vue